const defaultState = {
  currentCharger: null,
  configuration: {},
  fieldsPathMap: null,
  configurationFieldsRules: null,
  currentChargerImages: [],
  showSnackbar: false,
  errorCode: null,
  errorMessage: null,
  isFetching: false,
  resetError: '',
  resetErrorSnackbar: false,
  resetSuccessSnackbar: false,
  resetCommand: null,
  reinitForm: false,
  openResetDialogFlag: false,
  isConfigurationConfirmationDialogOpen: false,
  isNonLiveConfigurationParametersExists: false,
  configurationParametersSubmitError: null,
  isConfigurationSubmitFetching: false,
  showConfigurationLockedPopup: false,
  lockedIds: null,
  lockInterval: null,
  isDiagnosticsAvailable: false,
  isConfigurationLockedByAnotherUser: false,
};

function chargerDetails(state = defaultState, action) {
  switch (action.type) {
    case 'CLEAR_STATE':
      return defaultState;
    case 'CHARGER_REQUEST':
      return {
        ...state,
        errorCode: null,
        errorMessage: null,
        isFetching: true,
      };
    case 'TOGGLE_FETCHING':
      return { ...state, isFetching: action.flag };
    case 'SET_ACTIVE_CHARGER_FORM':
      return { ...state, currentCharger: action.currentCharger, isFetching: false };
    case 'TOGGLE_SNACKBAR': // TODO: Need to be extracted to separate component
      return {
        ...state,
        showSnackbar: action.flag,
        resetErrorSnackbar: false,
        resetSuccessSnackbar: false,
      };
    case 'TOGGLE_REINIT_FORM':
      return { ...state, reinitForm: action.flag };
    case 'SET_RESET_COMMAND':
      return { ...state, resetCommand: action.command };
    case 'OPEN_CHARGER_RESET_DIALOG':
      return { ...state, openResetDialogFlag: true, resetCommand: action.command };
    case 'CLOSE_CHARGER_RESET_DIALOG':
      return { ...state, openResetDialogFlag: false };
    case 'RESET_REQUEST_SUCCESS':
      return {
        ...state,
        isFetching: false,
        resetSuccessSnackbar: true,
        resetCommand: action.command,
      };
    case 'RESET_REQUEST_ERROR':
      return {
        ...state,
        isFetching: false,
        resetError: action.message,
        resetErrorSnackbar: true,
      };
    case 'SET_CHARGER_CONFIGURATION':
      return { ...state, configuration: action.configuration };
    case 'SET_CONFIGURATION_FIELD_MAP':
      return { ...state, fieldsPathMap: action.fieldsPathMap };
    case 'SELECT_CHARGER_CONFIGURATION_MODULE':
      return { ...state, selectedConfigurationModuleName: action.moduleName };
    case 'SET_NON_LIVE_PARAMETERS_EXIST':
      return { ...state, isNonLiveConfigurationParametersExists: action.isExist };
    case 'TOGGLE_CONFIGURATION_CONFIRMATION_DIALOG_OPEN':
      return {
        ...state,
        isConfigurationConfirmationDialogOpen: action.isOpen,
        configurationParametersSubmitError: action.isOpen ? null : state.configurationParametersSubmitError,
      };
    case 'SET_CONFIGURATION_PARAMETERS_SUBMIT_ERROR':
      return { ...state, configurationParametersSubmitError: action.message };
    case 'SET_CONFIGURATION_SUBMIT_FETCHING':
      return { ...state, isConfigurationSubmitFetching: action.isFetching };
    case 'TOGGLE_SHOW_CONFIGURATION_LOCKED_POPUP':
      return { ...state, showConfigurationLockedPopup: action.showLockedPopup };
    case 'SET_CHARGER_CONFIGURATION_LOCKED_IDS':
      return { ...state, lockedIds: action.lockedIds };
    case 'SET_CHARGER_CONFIGURATION_LOCK_INTERVAL':
      return { ...state, lockInterval: action.lockInterval };
    case 'SET_DIAGNOSTICS_AVAILABLE':
      return { ...state, isDiagnosticsAvailable: action.payload };
    case 'SET_LOCK_CONFIGURATION_BY_ANOTHER_USER':
      return { ...state, isConfigurationLockedByAnotherUser: action.isLocked };
    default:
      return state;
  }
}

export default chargerDetails;
